import React, { useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartBar } from '@fortawesome/free-solid-svg-icons';
import { Bar } from 'react-chartjs-2';
import { DataContext } from '../contexts/DataContext';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const StatusModulationCard = () => {
  const { data, isLoading } = useContext(DataContext);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!data) {
    return <div>No data available</div>;
  }

  // Process the data to count all different status_modulation values
  const modulationCounts = data.reduce((acc, item) => {
    const modulationStatus = item.status_modulacion;
    acc[modulationStatus] = (acc[modulationStatus] || 0) + 1;
    return acc;
  }, {});

  const chartData = {
    labels: Object.keys(modulationCounts),
    datasets: [
      {
        label: 'Status Modulation',
        data: Object.values(modulationCounts),
        backgroundColor: ['#4B77BE', '#5CACEE', '#77B1A9', '#72C6EF', '#8E44AD', '#3498DB', '#2ECC71', '#E74C3C'],
        hoverBackgroundColor: ['#354A5F', '#3E6B8E', '#5D8A76', '#5DA0C3', '#6C3483', '#2980B9', '#27AE60', '#C0392B'],
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    plugins: {
      datalabels: {
        color: '#f8f8f8', // Near white color for labels inside the bars
        font: {
          size: 14,
          family: 'Inter, sans-serif'
        },
        anchor: 'center', // Position labels at the center of each bar
        align: 'center', // Align labels in the middle of each bar
        formatter: (value, ctx) => {
          return value; // Displays the value of the bar as the label
        }
      },
      legend: {
        position: 'bottom',
        labels: {
          font: {
            size: 12,
            family: 'Inter, sans-serif',
            weight: '400',
            color: '#333'
          },
          boxWidth: 20,
          padding: 20,
        },
      },
      tooltip: {
        bodyFont: {
          size: 14,
          family: 'Inter, sans-serif',
          color: '#333'
        },
        titleFont: {
          size: 16,
          family: 'Inter, sans-serif',
          color: '#333'
        },
        backgroundColor: '#ffffff',
        borderColor: '#cccccc',
        borderWidth: 1,
        titleColor: '#333',
        bodyColor: '#333'
      }
    },
    scales: {
      x: {
        beginAtZero: true,
      },
    },
  };  
  

  return (
    <div className="bg-white shadow rounded-lg p-4 w-full max-w-lg flex flex-col justify-between h-custom-card-big overflow-y-auto">
      <div className="mb-4">
        <h2 className="text-lg font-bold text-gray-800 flex items-center">
          <FontAwesomeIcon icon={faChartBar} className="text-blue-600 mr-2" />
          Status Modulation
        </h2>
      </div>
      <div className="flex-grow relative h-full">
        <Bar data={chartData} options={options} />
      </div>
      <div className="mt-4">
        <table className="w-full text-sm text-left text-gray-500">
          <thead className="text-xs text-gray-700 uppercase bg-gray-50">
            <tr>
              <th scope="col" className="px-6 py-3">Status</th>
              <th scope="col" className="px-6 py-3">Count</th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(modulationCounts).map(([status, count]) => (
              <tr key={status} className="bg-white border-b">
                <td className="px-6 py-4">{status}</td>
                <td className="px-6 py-4">{count}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
  
};

export default StatusModulationCard;
